import { render, staticRenderFns } from "./OfficeDetails.vue?vue&type=template&id=5a16df74&scoped=true&"
import script from "./OfficeDetails.vue?vue&type=script&lang=ts&"
export * from "./OfficeDetails.vue?vue&type=script&lang=ts&"
import style0 from "./OfficeDetails.vue?vue&type=style&index=0&id=5a16df74&scoped=true&lang=css&"
import style1 from "./OfficeDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a16df74",
  null
  
)

export default component.exports